import { z } from 'zod';
import { phoneRegex } from '../regex';

const emailSchema = z.string().email('ایمیل معتبر نیست');
const phoneSchema = z.string().regex(phoneRegex, 'فرمت شماره موبایل یا ایمیل معتبر نیست.');

export const phoneNumberSchema = z.union([phoneSchema, emailSchema]);

export const SignInSchema = z.object({
    username: phoneNumberSchema
});

export const ResetPasswordSchema = z
    .object({
        password: z.string().min(4, 'رمز عبور را وارد کنید'),
        password_confirmation: z.string().min(4, 'تکرار رمز عبور را وارد کنید')
    })
    .refine((data) => data.password === data.password_confirmation, {
        path: ['password_confirmation'],
        message: 'رمز عبور و تکرار آن یکسان نیستند'
    });

export const SignUpSchema = ResetPasswordSchema.safeExtend({
    first_name: z.string().nonempty('نام را وارد کنید'),
    last_name: z.string().nonempty('نام خانوادگی را وارد کنید')
});

export const verificationCodeSchema = z.object({
    verification_code: z
        .string({ message: 'وارد کردن کد الزامی میباشد.' })
        .min(4, 'کد باید دقیقاً ۴ رقم باشد')
        .max(4, 'کد باید دقیقاً ۴ رقم باشد')
        .regex(/^\d{4}$/, 'کد باید فقط شامل ارقام باشد')
});

export const loginWithPassword = z.object({
    password: z.string({ message: 'وارد کردن رمز عبور الزامی میباشد.' }).min(4, 'رمز عبور باید 4 کاراکتر باشد')
});

// Types
export type SignInFormValues = z.infer<typeof SignInSchema>;
export type SignUpFormValues = z.infer<typeof SignUpSchema>;
export type ResetPasswordFormValues = z.infer<typeof ResetPasswordSchema>;
export type VerificationCodeFormValues = z.infer<typeof verificationCodeSchema>;
export type LoginWithPasswordFormValues = z.infer<typeof loginWithPassword>;
